jQuery( function($){

    var $text = $('.js-homeSomos__text');
    var next_revealable_index = 0;
    var $body = $('body');

    if(!$text.length){
        return;
    }

    setTimeout(function(){
        setupWordsAndCovers();
        setupSentences();
    },1000);

    function setupWordsAndCovers(){
        var text_string = $text.text();
        $text.empty();
        var sentences = text_string.split('|');

        for (var i = 0; i < sentences.length; i ++ ){
            var words = sentences[i].split(' ');
            var $sentence = $('<span class="homeSomos__sentence"></span>');
            for (var j = 0; j < words.length; j ++ ){
                $sentence.append(' <span class="homeSomos__word">' + words[j] + '</span>');
            }
            $text.append( $sentence );
        }
    }

    function setupSentences(){
        var $sentences = $('.homeSomos__sentence');
        $sentences.each( function (i,el){
            var $this = $(el);
            $this.data('revealed', false);
            $this.data('reveal-index', i);

            setupSentenceCovers( $this );
            $this
                .on('mouseenter', function (){
                    tryReveal($this);
                })
                .on('touchstart', function (){
                    tryReveal($this)
                });

        });
    }

    function setupSentenceCovers( $sentence ){
        var $words = $sentence.find('.homeSomos__word');

        var cover_start_x = $words.eq(0).offset().left;
        var cover_start_y = $words.eq(0).offset().top;
        var cover_end_x, cover_height;

        $words.each( function (i,el){
           var $this = $(el);
           var offset_top = $this.offset().top;
           var offset_left = $this.offset().left;
           cover_height = $this.height();

           if( offset_top != cover_start_y ){
               createCover( $sentence, cover_start_x, cover_start_y, cover_end_x, cover_height );
               cover_start_x = offset_left;
               cover_start_y = offset_top;
           }

           cover_end_x = $this.offset().left + $this.width();

           if( i === $words.length - 1 ){
               createCover( $sentence, cover_start_x, cover_start_y, cover_end_x, cover_height );
           }

        });

    }

    function createCover(  $sentence, cover_start_x, cover_start_y, cover_end_x, cover_height ){
        var covers_array = $sentence.data('covers') || [];
        var $cover = $('<span class="homeSomos__cover">');
        $cover.css({
            left: cover_start_x,
            top: cover_start_y,
            width: cover_end_x - cover_start_x,
            height: cover_height
        });
        covers_array.push( $cover );
        $body.append( $cover );
        $sentence.data('covers', covers_array );
    }

    function tryReveal( $sentence ) {
        var reveal_index = $sentence.data('reveal-index');
        var revealed = $sentence.data('revealed');

        if(!revealed){
            if( reveal_index !== next_revealable_index ){
                fakeReveal( $sentence );
            } else {
                realReveal($sentence);
                next_revealable_index ++;
            }
        }
    }

    function fakeReveal( $sentence ) {
        var covers = $sentence.data('covers');
        if(!covers.length){
            return;
        }
        covers[0].addClass('revealing');
        setTimeout(function (){
            covers[0].removeClass('revealing');
        }, 500);
    }

    function realReveal( $sentence ){
        var covers = $sentence.data('covers');
        if(!covers.length){
            return;
        }

        var $one_cover = covers.shift();
        $one_cover.addClass('revealed');
        if( covers.length ){
            $sentence.data('covers', covers);
            setTimeout(function (){
                realReveal($sentence)
            }, 200);
        }
    }








});